import { LoginErrorsEnum } from './login-errors.enum';

export const loginErrorAlerts: {[key: string]: {heading: string; body: string}} = {
  [LoginErrorsEnum.userNotFound]: {
    heading: 'Login failed.',
    body: 'Check your username and password and try again.',
  },
  [LoginErrorsEnum.userLoginFailed]: {
    heading: 'Login failed.',
    body: 'Check your username and password and try again.',
  },
  [LoginErrorsEnum.badUserState]: {
    heading: 'Error, bad user state.',
    body: 'Please email support@tablesready.com for help.',
  },
  [LoginErrorsEnum.badDatetime]: {
    heading: 'Login failed.',
    body: 'Your device clock is incorrect. Please change your Date & Time to be set automatically. <a href="https://support.tablesready.com/article/26-error-logging-in-date-time-or-timezone-are-wrong" target="_blank">Learn more</a>.',
  },
  [LoginErrorsEnum.userDisabled]: {
    heading: '',
    body: 'Your account has been disabled by the service administrator. Please contact us if you  have any questions.',
  },
  default: {
    heading: 'Error logging in: ',
    body: 'Please try again.',
  },
};
